import './_carousel-objectives.scss';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function CarouselObjectives() {
    const carouselObjectives = document.querySelectorAll('.carousel-objectives');

    if (carouselObjectives.length) {
        carouselObjectives.forEach((el, index) => {
            const carousel = el.querySelectorAll('.swiper-container');

            carousel.forEach((item: any) => {
                item.classList.add(`${index}`);

                const swiperBtnNext = el.querySelector('.swiper-button-next') as HTMLElement;
                const swiperBtnPrev = el.querySelector('.swiper-button-prev') as HTMLElement;
                const pagination = el.querySelector('.swiper-pagination') as HTMLElement;
                const swiperSlide = el.querySelectorAll('.swiper-slide');

                if (swiperBtnPrev && swiperBtnNext && pagination) {
                    swiperBtnNext.classList.add(`next-${index}`);
                    swiperBtnPrev.classList.add(`prev-${index}`);
                    pagination.classList.add(`pagination-${index}`);
                }

                const swiper = new Swiper(item, {
                    modules: [Navigation, Pagination],
                    loop: swiperSlide.length > 1,
                    pagination: {
                        el: `.pagination-${index}`,
                        clickable: true,
                    },
                    slidesPerGroup: 1,
                    slidesPerView: 1,
                    navigation: {
                        nextEl: swiperBtnNext,
                        prevEl: swiperBtnPrev,
                        addIcons: false,
                    },
                    on: {
                        afterInit: function () {
                            const bullets = pagination.querySelectorAll('.swiper-pagination-bullet');
                            bullets.forEach((bullet: any) => {
                                bullet.setAttribute('tabindex', '0');
                                bullet.addEventListener('keydown', (event: any) => {
                                    if (event.key === 'ArrowLeft') {
                                        event.preventDefault();
                                        swiper.slidePrev();
                                    } else if (event.key === 'ArrowRight') {
                                        event.preventDefault();
                                        swiper.slideNext();
                                    }
                                });
                            });
                        },
                        slideChange: function () {
                            if (pagination) {
                                const currentSlide = pagination.querySelector('.swiper-pagination-bullet.swiper-pagination-bullet-active') as HTMLDivElement;
                                if (currentSlide) {
                                    currentSlide.focus();
                                }
                            }
                        },
                    },
                });

                if (swiperBtnNext) {
                    swiperBtnNext.addEventListener('keypress', function (e) {
                        if (e.code === 'Enter') {
                            swiper.slideNext();
                        }
                    });
                }

                if (swiperBtnPrev) {
                    swiperBtnPrev.addEventListener('keypress', function (e) {
                        if (e.code === 'Enter') {
                            swiper.slidePrev();
                        }
                    });
                }

                swiper.init();
            });
        });
    }
}
